/**
 * Copyright © Amazon.com and Affiliates: This deliverable is considered Developed Content as defined in the AWS Service Terms 
 * and the SOW between the parties dated 10/31/2024.
 */
import { Component, EventEmitter, Input, Output, CUSTOM_ELEMENTS_SCHEMA } from '@angular/core';
import { CommonModule } from '@angular/common';

export enum ShareModalState {
  CONFIRMATION = 'confirmation',
  LOADING = 'loading',
  SUCCESS = 'success'
}

@Component({
  selector: 'app-share-confirmation-modal',
  standalone: true,
  imports: [CommonModule],
  templateUrl: './share-confirmation-modal.component.html',
  styleUrl: './share-confirmation-modal.component.css',
  schemas: [CUSTOM_ELEMENTS_SCHEMA]
})
export class ShareConfirmationModalComponent {
  @Input() visible = false;
  @Input() reportTitle = '';
  @Output() confirmed = new EventEmitter<void>();
  @Output() cancelled = new EventEmitter<void>();
  @Output() closed = new EventEmitter<void>();

  currentState: ShareModalState = ShareModalState.CONFIRMATION;
  ShareModalState = ShareModalState; // Expose enum to template

  /**
   * Handles Yes button click in confirmation state
   */
  onYesClicked(): void {
    this.currentState = ShareModalState.LOADING;
    this.confirmed.emit();
  }

  /**
   * Handles No button click in confirmation state
   */
  onNoClicked(): void {
    this.cancelled.emit();
  }

  /**
   * Handles Close button click in success state
   */
  onCloseClicked(): void {
    this.closed.emit();
  }

  /**
   * Transitions modal to success state
   */
  showSuccess(): void {
    this.currentState = ShareModalState.SUCCESS;
  }

  /**
   * Resets modal to initial confirmation state
   */
  reset(): void {
    this.currentState = ShareModalState.CONFIRMATION;
  }
}
